import { render, staticRenderFns } from "./ProductLabel.vue?vue&type=template&id=f240a6d2&"
import script from "./ProductLabel.vue?vue&type=script&lang=js&"
export * from "./ProductLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports